"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const material_1 = require("@mui/material");
const Drawer_1 = tslib_1.__importDefault(require("@mui/material/Drawer"));
const styles_1 = require("./styles");
const MneDrawer = (0, material_1.styled)(Drawer_1.default, { shouldForwardProp: (prop) => prop !== "open" })(({ theme, open }) => ({
    width: styles_1.MENU_WIDTH_OPEN,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    ...(open && {
        ...(0, styles_1.openedMixin)(theme),
        "& .MuiDrawer-paper": {
            ...(0, styles_1.openedMixin)(theme),
            height: `calc(100vh - ${styles_1.DRAWER_FOOTER_HEIGHT}px)`,
        },
    }),
    ...(!open && {
        ...(0, styles_1.closedMixin)(theme),
        "& .MuiDrawer-paper": {
            ...(0, styles_1.closedMixin)(theme),
            height: `calc(100vh - ${styles_1.DRAWER_FOOTER_HEIGHT}px)`,
        },
    }),
}));
exports.default = MneDrawer;
